export default __webpack_public_path__ + "static/media/csm_job13-182-chim-00362-id-417469-jpeg_b5f8fb8ff0.a5e7bc7d.jpg";